import {TrustBlockContent} from '../TrustBlockContent'

type Props = {
  prefix: string
  defaultTitle: string
}

export const TrustBlockTitle = ({prefix, defaultTitle}: Props) => {
  return <TrustBlockContent prefix={prefix} defaultText={defaultTitle} />
}
